/* lua.js generated code undefined */

let DASchemeConfig = require("clover/config/userTag/DASchemeConfig")
const Event = require("cocos/framework/components/event")
DAManager = xClass("DAManager", Event)
let DA_EXPIRE_DURATION = 3600 * 24 * 1
let _instance = null
DAManager.getInstance = function () {
    let self = this
    if (!_instance) {
        _instance = DAManager.new()
    }
    return _instance
}
DAManager.prototype.ctor = function () {
    let self = this
    self._currentSchemeCfg = null
    self._currentMostColor = 0
    self.load()
}
DAManager.prototype.useV2 = function () {
    let self = this
    return false
}
DAManager.prototype.getCube = function () {
    let self = this
    return "a"
}
DAManager.prototype.reset = function () {
    let self = this
    self._expectCountCache = table()
    self._natureDiffCache = table()
    self._updateTimeCache = table()
    self._currentSchemeCfg = null
    self._currentMostColor = 0
}
DAManager.prototype.load = function () {
    let self = this
    let data = Localhost.getDropAdjustData()
    self._expectCountCache = data.expectCountCache || table()
    self._natureDiffCache = data.natureDiffCache || table()
    self._updateTimeCache = data.updateTimeCache || table()
    self.loadSchemeCfg()
}
// DAManager.prototype.loadTestTagConfig = function (testTagCfg) {
//     let self = this
//     if (GameSpeedUp.getInstance().isInGame) {
//         return 
//     }
//     self._testTagCfg = testTagCfg
//     Toast.make("【掉落优化Tag】测试标签配置")
// }
// DAManager.prototype.loadTestSchemeConfig = function (testSchemeCfg) {
//     let self = this
//     if (GameSpeedUp.getInstance().isInGame) {
//         return 
//     }
//     self.loadSchemeCfg(testSchemeCfg)
//     Toast.make("【掉落优化Scheme】测试方案配置")
// }
DAManager.prototype.getTestTagCfg = function () {
    let self = this
    return self._testTagCfg || table()
}
// 加载方案配置，并按优先级排序
DAManager.prototype.loadSchemeCfg = function (testCfg) {
    let self = this
    self._schemeCfg = table()
    let cfg = testCfg || UserTagData.getInstance().DASchemeConfig
    for (let k in cfg) {
        let v = cfg[k]
        if ($null(v)) continue
        v.dcName = DASchemeConfig[k].dcName
        table.insert(self._schemeCfg, v)
    }
    if (testCfg) {
        self._testFuuuExpects = testCfg.Scheme_fuuu.testExpects
    }
    // 按优先级排序（数字越小，优先级越高，届时优先选择方案）
    table.sort(self._schemeCfg, function (a, b) {
        return a.priority < b.priority
    })
}
// DAManager.prototype.flushData = function () {
//     let self = this
//     let data = table(
//         [1, "expectCountCache", self._expectCountCache],
//         [1, "natureDiffCache", self._natureDiffCache],
//         [1, "updateTimeCache", self._updateTimeCache]
//     )
//     Localhost.setDropAdjustData(data)
// }
// 获取指定关卡的目标期望完成数列表
//     {
//         [1] = 1,
//         [2] = 3,
//         [3] = 332,
//         [4] = 444,
//     }
DAManager.prototype.getExpectCountList = function (levelId) {
    // let self = this
    // if (self._testFuuuExpects && $len(self._testFuuuExpects) > 0) {
    //     return self._testFuuuExpects
    // }
    // levelId = tostring(levelId)
    // return self._expectCountCache[levelId] || table()
    return UserManager.getInstance().userLabel.except
}
// 获取指定关卡的自然难度
// DAManager.prototype.getNatureDiff = function (levelId) {
//     let self = this
//     levelId = tostring(levelId)
//     return self._natureDiffCache[levelId] || 999
// }
DAManager.prototype.parseCompleteExpect = function (str) {
    let self = this
    let ret = table()
    let l = string.split(str, ",")
    let $limit24 = $len(l)
    for (let i = 1; i <= $limit24; i += 1) {
        let v = string.split(l[i], ":")
        ret[tonumber(v[1])] = tonumber(v[2])
    }
    // he_log_info("ret length:"..tostring(#ret))
    return ret
}
// 检查缓存的记录中有哪些已经过期了（没有数据也视作过期）
// DAManager.prototype.checkExpire = function (levelId) {
//     let self = this
//     levelId = tostring(levelId)
//     if (self._updateTimeCache[levelId]) {
//         let now = Localhost.timeInSec()
//         return now - self._updateTimeCache[levelId] >= DA_EXPIRE_DURATION
//     } else {
//         return true
//     }
// }
// 获取目前最需要更新的n个关卡
// DAManager.prototype.getUpdateList = function (maxCount, testTopLevel, testPassedLevel) {
//     let self = this
//     maxCount = maxCount || 30
//     let topLevel = testTopLevel && testTopLevel || UserManager.getInstance().getUserRef().getTopLevelId()
//     let passedLevel = testPassedLevel && testPassedLevel || UserManager.getInstance().getPassedTopLevel()
//     let curId = Math.max(0, passedLevel - Math.floor(maxCount / 2))
//     let levels = table()
//     let count = 1
//     while (count < maxCount && curId <= topLevel) {
//         if (self.checkExpire(curId)) {
//             table.insert(levels, curId)
//             count = count + 1
//         }
//         curId = curId + 1
//     }
//     return levels
// }
// 尝试从服务器更新关卡的自然难度及每步的目标期望完成度
// DAManager.prototype.tryUpdateData = function () {
//     let self = this
//     function onSuccess(evt) {
//         he_log_info("update level diffexpect success!")
//         if (evt.data) {
//             // if __DEBUG and __WIN32 and #evt.data == 0 then
//             //     evt.data = {
//             //         targetCompleteExpectConfig = {}
//             //     }
//             //     local levels = self:getUpdateList()
//             //     for _, v in pairs(levels) do
//             //         table.insert(evt.data.targetCompleteExpectConfig,  {
//             //             levelId = v,
//             //             completeExpect = "1:1,2:3,3:332,4:444",
//             //             natureDiff = math.random() * 100,
//             //         })
//             //     end
//             // end
//             let config = evt.data.targetCompleteExpectConfig
//             for (let _ in config) {
//                 let v = config[_]
//                 if ($null(v)) continue
//                 let levelId = tostring(v.levelId)
//                 self._expectCountCache[levelId] = self.parseCompleteExpect(v.completeExpect)
//                 self._natureDiffCache[levelId] = v.natureDiff
//                 self._updateTimeCache[levelId] = Localhost.timeInSec()
//             }
//             self.flushData()
//         }
//     }
//     function onFail(evt) {
//         he_log_info("update level diffexpect failed:" + evt.data)
//     }
//     function onCancel() {
//         let __VA_ARG = $slice(arguments, 0)
//         he_log_info("update level diffexpect canceled")
//     }
//     let levels = self.getUpdateList()
//     if ($len(levels) > 0) {
//         // dump(levels,"need update list")
//         // debug.debug()
//         let http = GetLevelDiffExpectHttp.new(false)
//         http.addEventListener(Events.kComplete, onSuccess)
//         http.addEventListener(Events.kError, onFail)
//         http.addEventListener(Events.kCancel, onCancel)
//         http.load(levels)
//     }
// }
// DAManager.prototype.getNature20Diff = function (levelId) {
//     let self = this
//     cc.log("【掉落优化】getNature20Diff old=0")
//     return 0
// }
DAManager.prototype.startLevel = function (levelId, recoverData) {
    let self = this
    DAManagerGUILogger.getInstance().reset()
    DAManagerGUILogger.getInstance().print("日志清理")
    self._levelId = levelId
    self.hasIntervened = false
    self._currentSchemeCfg = null
    self._passiveRefreshCount = 0
    if (recoverData && recoverData.replay && recoverData.replay.passiveRefreshCount) {
        self.setPassiveRefreshCount(recoverData.replay.passiveRefreshCount)
    }
    // AI打关不使用任何干预策略
    // if (__robot || __CNN) {
    //     DAManagerGUILogger.getInstance().print("AI打关不使用任何干预策略")
    //     return 
    // }
    // 只对主线关卡生效
    let levelType = LevelType.getLevelTypeByLevelId(levelId)
    if (levelType !== GameLevelType.kMainLevel) {
        console.log("非主线关不使用任何干预策略");
        // DAManagerGUILogger.getInstance().print("非主线关不使用任何干预策略")
        return 
    } else {
        // 只对玩家未通关的关卡生效（刷关不生效）
        let passedTopLevel = UserManager.getInstance().getPassedTopLevel()
        if (levelId <= passedTopLevel) {
            console.log("刷关不使用任何干预策略");
            // DAManagerGUILogger.getInstance().print("刷关不使用任何干预策略")
            return 
        }
    }

    //高手攻略播放，对刷关的攻略不使用任何干预策略
    //  if(recoverData && recoverData.replay && recoverData.replay.dropAdjustScheme)
    //  {
    //      if (table.serialize(recoverData.replay.dropAdjustScheme) == table.serialize(table()))
    //      {
    //          return 
    //      }
    // }

    self._inLevel = true
    self.chooseScheme(levelId, recoverData)
}
// 在bonus time之前调用，表示关卡常规阶段结束
DAManager.prototype.endLevel = function () {
    let self = this
    self._inLevel = false
}
DAManager.prototype.refreshEndLevelStatus = function (isWin) { }
DAManager.prototype.encodeScheme = function () {
    let self = this
    let data = {
        currentSchemeCfg: self._currentSchemeCfg
    }
    return data
}
/*     @desc: 在关卡开始时决定干预方案
	--@levelId: 关卡号
	--@recoverData: 闪退续打数据
    @return:
 */
DAManager.prototype.chooseScheme = function (levelId, recoverData) {
    let self = this
    console.log("chooseScheme")
    // 闪退续打
    if (recoverData && recoverData.replay && recoverData.replay.dropAdjustScheme) {
        // if (__WIN32) {
            // 这里只是给QA测试用
            // let difficultyTag = UserTagData.getInstance().getTag(UserTagEnum.PersonalDifficulty, levelId)
        // }
        if (table.serialize(recoverData.replay.dropAdjustScheme) == table.serialize(table())){
            self._currentSchemeCfg = null
        }else {
            self._currentSchemeCfg = recoverData.replay.dropAdjustScheme
        }
        console.log("替换dropAdjustScheme _currentSchemeCfg", self._currentSchemeCfg)
        let ps = ""
        if (self._currentSchemeCfg) {
            ps = "掉落优化选择方案（闪退续打）：【" + self._currentSchemeCfg.description + "】"
        } else {
            ps = "没有选到方案（闪退续打）"
        }
        ps = ps + "\n----------------------------------------------"
        // DAManagerGUILogger.getInstance().print(ps)
        cc.log(ps)
    } else {
        self._currentSchemeCfg = null
        let difficultyTag = UserTagData.getInstance().getTag(UserTagEnum.PersonalDifficulty, levelId)
        // if (__WIN32) {
        //     difficultyTag = -1
        // }
        // 这段代码不要删！！！因为关卡策划使用win版模拟器不能走掉落优化！！！
        let schemes = table()
        let planMeta = UserTagData.getInstance().applyConfig;
        for (let k in planMeta) {
            let plans = planMeta[k]
            if ($null(plans)) continue
            let orthId = tonumber(plans.testId)
            let enableTest = OrthGroupHelper.getInstance().getEnableTest(orthId)
            if (enableTest) {
                // 3. 玩家所在分组编号
                let group = OrthGroupHelper.getInstance().getTestGroupIndex(orthId)
                if (self._testTagCfg) {
                    difficultyTag = self._testTagCfg.difficultyTag || difficultyTag
                }
                // 4. 在配置中查找对应的方案
                let orthItem = OrthGroupHelper.getInstance().getTestGroupItem(orthId)
                if (orthItem) {
                    let groupName = orthItem.testGroup[group - 1].group;
                    console.log("plans", plans);
                    console.log("groupName", groupName, table.exist(plans.testGroup, groupName));
                    console.log("difficultyTag", difficultyTag, table.exist(plans.diffTag, difficultyTag));
                    if (table.exist(plans.testGroup, groupName) && table.exist(plans.diffTag, difficultyTag)) {
                        table.insert(schemes, plans.dropAdjustPlan)
                    }
                }
            }
        }
        if (__WIN32) {
            cc.log("可选方案：" + table.tostring(schemes))
            // DAManagerGUILogger.getInstance().print("可选方案：" + table.tostring(schemes))
        }
        // 注意，接下来的遍历是按序的（self._schemeCfg在之前已经按优先级排过序了）
        for (let i = 1, cfg = self._schemeCfg[1]; cfg; i++, cfg = self._schemeCfg[i]) {
            if (table.exist(schemes, cfg.id)) {
                self._currentSchemeCfg = cfg
                break
            }
        }
        // 5. 打印方案信息
        cc.log("【掉落优化】---------------------------------------------------------------------------")
        if (self._testTagCfg) {
            cc.log("正在使用【测试配置】")
            // DAManagerGUILogger.getInstance().print("正在使用【测试配置】")
        }
        cc.log("\t\t个人难度标签：" + difficultyTag)
        DAManagerGUILogger.getInstance().print("\t\t个人难度标签：" + difficultyTag)
        if (self._currentSchemeCfg) {
            let ps = "掉落优化选择方案：【" + self._currentSchemeCfg.description + "】"
            ps = ps + "\n----------------------------------------------"
            cc.log(ps)
            // DAManagerGUILogger.getInstance().print(ps)
        } else {
            let ps = "没有选到方案"
            ps = ps + "\n----------------------------------------------"
            cc.log(ps)
            // DAManagerGUILogger.getInstance().print(ps)
        }
        cc.log("【掉落优化】---------------------------------------------------------------------------")
    }
    // 准备掉落口统计
    self.resetDropStats()
}
DAManager.prototype.getCurrentSchemeCfg = function () {
    let self = this
    return self._currentSchemeCfg
}
// 重置掉落口颜色统计
DAManager.prototype.resetDropStats = function () {
    let self = this
    // DAManagerGUILogger.getInstance().print("重置掉落口颜色统计")
    console.log("重置掉落口颜色统计")
    self._dropStats = table([1, "single", table()], [1, "global", table()])
    let $var69 = GameColor.kBlue,$limit70 = GameColor.kYellow
    for (let i = $var69; i <= $limit70; i += 1) {
        self._dropStats.global[i] = table([1, "m", 0], [1, "n", 0])
    }
}
DAManager.prototype.checkAdjustStrategy = function (strategyId) { }
DAManager.prototype.registAdjustStrategy = function (name, adjustPlan) { }
DAManager.prototype.clearAdjustStrategy = function (name) { }
// 尝试进行干预
DAManager.prototype.tryInterveneAnimal = function (mainLogic, r, c, preColor) {
    let self = this
    if (!self._inLevel || preColor === self._currentMostColor) {
        console.log("掉落口颜色和最多的颜色相同，防止同时生成连续3个以上的颜色")
        // 防止出现同色3连
        let correctColor = ProductItemLogic.checkSameProductColor(mainLogic, r, c, preColor, true)
        return correctColor
    }
    // if (__robot || __CNN) {
    //     Toast.make("机器人不能进行掉落干预！修了这bug！", 30)
    // }
    let resultColor = preColor
    let probabilityPass = false
    if (self._currentSchemeCfg && self._currentMostColor > 0) {
        let rand = mainLogic.randomValue(1, 100)
        console.log("rand", rand, "probability", self._currentSchemeCfg.probability)
        if (rand < self._currentSchemeCfg.probability * 100) {
            probabilityPass = true
        }
    }
    if (probabilityPass) {
        // 单掉落口限制
        let singlePass = false
        let key = r + "_" + c
        if (!self._dropStats.single[key]) {
            self._dropStats.single[key] = table()
            let $var78 = GameColor.kBlue,$limit79 = GameColor.kYellow
            for (let i = $var78; i <= $limit79; i += 1) {
                self._dropStats.single[key][i] = table([1, "m", 0], [1, "n", 0])
            }
        }
        let singleData = self._dropStats.single[key][self._currentMostColor]
        singleData.m = singleData.m + 1
        if (singleData.m > self._currentSchemeCfg.dropPort.single.m) {
            singleData.m = 0
            singleData.n = 0
        }
        let singleCount = singleData.n + 1
        if (singleCount <= self._currentSchemeCfg.dropPort.single.n) {
            singlePass = true
        }
        // 全局限制
        let globalPass = false
        let globalData = self._dropStats.global[self._currentMostColor]
        globalData.m = globalData.m + 1
        if (globalData.m > self._currentSchemeCfg.dropPort.global.m) {
            globalData.m = 0
            globalData.n = 0
        }
        let globalCount = globalData.n + 1
        if (globalCount <= self._currentSchemeCfg.dropPort.global.n) {
            globalPass = true
        }
        if (__WIN32) {
            let ps = "【掉落优化】singleCount: " + singleCount + ", globalCount: " + globalCount
            // DAManagerGUILogger.getInstance().print(ps)
            console.log(ps)
        }
        if ((singlePass && globalPass) || preColor === self._currentMostColor) {
            singleData.n = singleCount
            globalData.n = globalCount
            resultColor = self._currentMostColor
            self.hasIntervened = true
            let ps = "【掉落优化】干预掉落：(" + r + ", " + c + ") Color[" + preColor + "] -> Color[" + resultColor + "]"
            console.log(ps)
            // DAManagerGUILogger.getInstance().print(ps)
        }
    }
    // 防止出现同色3连
    let correctColor = ProductItemLogic.checkSameProductColor(mainLogic, r, c, resultColor, true)
    if (resultColor !== correctColor) {
        let ps = "【掉落优化】防止同色3连：(" + r + ", " + c + ") Color[" + resultColor + "] -> Color[" + correctColor + "]"
        console.log(ps)
        // DAManagerGUILogger.getInstance().print(ps)
    }
    resultColor = correctColor
    resultColor = resultColor || preColor
    return resultColor
}
// 查找棋盘中最多的颜色
DAManager.prototype.findMostColorAfterFallingStable = function (mainLogic) {
    let self = this
    if (!self._inLevel) {
        return 
    }
    let mostColor = 0
    let enableFind = false
    if (self._currentSchemeCfg) {
        if (self._currentSchemeCfg.fuuu) {
            // fuuu干预
            // fuuu干预首先要满足3个基本条件：1. 目标完成数低于期望；2. 剩余步数大于一定步数；3. 没有达到fuuu状态
            let isFuuuState = self.checkFuuuState(mainLogic)
            console.log("isFuuuState", isFuuuState)
            if (!isFuuuState) {
                let count = DATargetCounter.getInstance().getCurrentTargetCount()
                let expect = DATargetCounter.getInstance().getCurrentExpectCount()
                let ps = "【掉落优化FUUU】当前目标数：" + count + "，期望：" + expect
                if (self._lastFuuuCEStr !== ps) {
                    self._lastFuuuCEStr = ps
                    // DAManagerGUILogger.getInstance().print(ps)
                    console.log(ps)
                }
                let checkExpect = count < expect * self._currentSchemeCfg.fuuu.expectRatio
                let checkEnoughStep = mainLogic.getTheCurMoves() > self._currentSchemeCfg.fuuu.stopLeftSteps
                if (checkExpect && checkEnoughStep) {
                    enableFind = true
                }
            } else {
                // DAManagerGUILogger.getInstance().print("已达到FUUU状态")
                console.log("已达到FUUU状态")
            }
        } else {
            // 普通干预
            // 注意，这里并不意味着最终一定干预，因为在后续tryInterveneAnimal中还有掉落口限制
            enableFind = true
        }
    }
    if (enableFind) {
        // 查找棋盘颜色最多的那个
        let counts = table()
        let $var100 = GameColor.kBlue,$limit101 = GameColor.kYellow
        for (let i = $var100; i <= $limit101; i += 1) {
            counts[i] = 0
        }
        let max = 0
        let gameItemMap = GameBoardLogic.instance.gameItemMap
        let $limit106 = $len(gameItemMap)
        for (let r = 1; r <= $limit106; r += 1) {
            let $limit109 = $len(gameItemMap[r])
            for (let c = 1; c <= $limit109; c += 1) {
                let itemData = gameItemMap[r][c]
                if (itemData.itemType === GameItemType.kAnimal) {
                    let color = itemData.itemColorType || itemData.color
                    if (color && color >= GameColor.kBlue && color <= GameColor.kYellow) {
                        let v = counts[color] + 1
                        counts[color] = v
                        if (v > max) {
                            mostColor = color
                            max = v
                        }
                    }
                }
            }
        }
        if (__WIN32) {
            let str = "【掉落优化】统计棋盘中颜色："
            for (let c = 1, v = counts[1]; v; c++, v = counts[c]) {
                str = str + "[" + c + "]: " + v + " "
            }
            str = str + "[Most]: " + mostColor
            // cc.log(str)
            if (self._lastMostColorStr !== str) {
                self._lastMostColorStr = str
                // DAManagerGUILogger.getInstance().print(str)
                console.log(str)
            }
        }
    }
    self._currentMostColor = mostColor
}
// 检查是否达到了fuuu状态
DAManager.prototype.checkFuuuState = function (mainLogic) {
    let self = this
    let ret = false
    let gameMode = mainLogic.theGamePlayType
    let stopTargetNum = self._currentSchemeCfg.fuuu.stopTargetNum
    if (gameMode === GamePlayType.kBoss) {
        let bossList = mainLogic.gameMode.bossList
        let leftHp = 0
        let $limit124 = $len(bossList)
        for (let i = 1; i <= $limit124; i += 1) {
            let hp = bossList[i].getCurrentHp()
            leftHp = leftHp + hp
        }
        ret = leftHp <= stopTargetNum.kBoss
    } else if (gameMode === GamePlayType.kPursue) {
        let movedSteps = mainLogic.gameMode.getFinishInfo()
        let [r, c] = mainLogic.gameMode.getItemStartRC()
        let road = mainLogic.getRoadByRC(r, c)
        if (road) {
            let leftSteps = $len(road.map) - movedSteps - 1
            ret = leftSteps <= stopTargetNum.kPursue
        }
    } else {
        let ownNum = 0
        let targetNum = 0
        for (let i = 1, v = mainLogic.theOrderList[1]; v; i++, v = mainLogic.theOrderList[i]) { // v: GameItemOrderData
            ownNum = ownNum + v.ownNum
            targetNum = targetNum + v.targetNum
        }
        let leftTarget = targetNum - ownNum
        if (gameMode === GamePlayType.kOrder && leftTarget <= stopTargetNum.kOrder) {
            ret = true
        } else if (gameMode === GamePlayType.kIce && leftTarget <= stopTargetNum.kIce) {
            ret = true
        } else if (gameMode === GamePlayType.kWaterDig && leftTarget <= stopTargetNum.kWaterDig) {
            ret = true
        } else if (gameMode === GamePlayType.kFish && leftTarget <= stopTargetNum.kFish) {
            ret = true
        } else if (gameMode === GamePlayType.kBlockCollection && leftTarget <= stopTargetNum.kBlockCollection) {
            ret = true
        }
    }
    return ret
}
// 被动刷新重排的次数（不包括使用道具的主动重排）
DAManager.prototype.setPassiveRefreshCount = function (count) {
    let self = this
    self._passiveRefreshCount = count
    let replay = GameBoardLogic.instance.replay || ReplayManager.getInstance().getLastReplayByLevelId(self._levelId)
    if (replay) {
        replay.passiveRefreshCount = count
    }
}
DAManager.prototype.getPassiveRefreshCount = function () {
    let self = this
    return self._passiveRefreshCount
}

DAManager.prototype.clearAdjustStrategy = function (key) {

}
DAManager.prototype.registAdjustStrategy = function (key, obj) {

}

DAManager.prototype.checkAdjustStrategy = function (strategyId) {

}
module.exports = DAManager
